import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoading: false,
    ListStatus: false,
    UnreadNum: 0,
    Roomvisible: false,
    ShowRoom: false,
    OptionKeyword: '',
    Searchcountry: '',
    Searchpro: '',
    SearchArea: '',
    ChatEmail: '',
    exhcode: 'AC20E266CA74B6E9D16B8D25A47752B2',
    messages: [],
  },

  actions: {
    updateMessage(context, payload) {
      const timestamp = Math.floor(new Date() / 1000)
      const content = payload
      content.timestamp = timestamp

      context.commit('ALERTMESSAGE', content)

      setTimeout(() => {
        context.commit('REMOVEALERTWITHTIMIMG', content.timestamp)
      }, 1500)
    },
    removeMessage(context, payload) {
      context.commit('REMOVEALERT', payload)
    },
    updateLoading(context, status) {
      context.commit('LOADING', status)
    },
    updateList(context, status) {
      context.commit('OPENLIST', status)
    },

    getUnread(context, status) {
      context.commit('GETUNREAD', status)
    },

    Updatevisible(context, status) {
      context.commit('UPDATEVISIBLE', status)
    },

    Savekeyword(context, status) {
      context.commit('SAVEKEYWORD', status)
    },

    SaveOptionCountry(context, status) {
      context.commit('SAVEOPTIONCOUNTRY', status)
    },

    SaveOptionPro(context, status) {
      context.commit('SAVEOPTIONPRO', status)
    },

    SaveOptionArea(context, status) {
      context.commit('SAVEOPTIONAREA', status)
    },

    UpdateChatEmail(context, status) {
      context.commit('UPDATECHATEMAIL', status)
    },
  },
  mutations: {
    ALERTMESSAGE(state, payload) {
      state.messages.push(payload)
    },
    REMOVEALERT(state, payload) {
      state.messages.splice(payload, 1)
    },
    REMOVEALERTWITHTIMIMG(state, timestamp) {
      // console.log(timestamp)
      state.messages.forEach((item, index) => {
        if (item.timestamp === timestamp) {
          state.messages.splice(index, 1)
        }
      })
    },
    LOADING(state, status) {
      state.isLoading = status
    },

    OPENLIST(state, status) {
      state.ListStatus = status
    },

    GETUNREAD(state, status) {
      state.UnreadNum = status
    },

    UPDATEVISIBLE(state, status) {
      state.Roomvisible = status
    },

    SAVEKEYWORD(state, status) {
      state.OptionKeyword = status
    },

    SAVEOPTIONCOUNTRY(state, status) {
      state.Searchcountry = status
    },

    SAVEOPTIONPRO(state, status) {
      state.Searchpro = status
    },

    SAVEOPTIONAREA(state, status) {
      state.SearchArea = status
    },

    UPDATECHATEMAIL(state, status) {
      state.ChatEmail = status
    },
  },

  modules: {},

  getters: {
    isLoading: (state) => state.isLoading,
    ListStatus: (state) => state.ListStatus,
    UnreadNum: (state) => state.UnreadNum,
    Roomvisible: (state) => state.Roomvisible,
    OptionKeyword: (state) => state.OptionKeyword,
    Searchcountry: (state) => state.Searchcountry,
    Searchpro: (state) => state.Searchpro,
    SearchArea: (state) => state.SearchArea,
    ChatEmail: (state) => state.ChatEmail,
    ShowRoom: (state) => state.ShowRoom,
    exhcode: (state) => state.exhcode,
    messages: (state) => state.messages,
  },
})
